export const sumMatrix = (m: number[][]) => {
  let total = 0;

  m?.forEach((a) => {
    const s = a.length > 0 ? a.reduce((a, b) => a + b) : 0;
    total += s;
  });

  return total;
};

export const sumMatrixOfMatrix = (mm: number[][][]) => {
  let total = 0;

  mm?.forEach((m) => {
    m?.forEach((a) => {
      const s = a.length > 0 ? a.reduce((a, b) => a + b) : 0;
      total += s;
    });
  });

  return total;
};

export const sumMatrixColumn = (m: number[][], c: number) => {
  let total = 0;

  m?.forEach((a) => {
    const s =
      a?.filter((item, i) => i === c)?.length > 0
        ? a?.filter((item, i) => i === c)?.reduce((a, b) => a + b)
        : 0;
    total += s;
  });

  return total;
};
